import * as types from '../../action-types';
import { getISOSingleRepayment as initialState } from "../../initialState";

const getISOSingleRepayment = (state=initialState, action) => {
  switch (action.type) {
    case types.GET_ISO_SINGLE_REPAYMENT_START:
      return {
        ...state,
        isLoading: true
      };
    case types.GET_ISO_SINGLE_REPAYMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.GET_ISO_SINGLE_REPAYMENT_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.GET_ISO_SINGLE_REPAYMENT_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default getISOSingleRepayment;
